const STORAGE_KEY = 'autoqm_signup_referral';

// Keep the referral through full-page login and OAuth navigation in this tab.
export function saveSignupReferral(value: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, value.trim());
  } catch {
    // Storage may be disabled; the current form and explicit URL still work.
  }
}

export function getSignupReferral(search = window.location.search, from?: string | null): string {
  const params = new URLSearchParams(search);
  let value = params.get('ref');
  const destination = from || params.get('redirect');
  if (value === null && destination) {
    try {
      value = new URL(destination, window.location.origin).searchParams.get('ref');
    } catch { /* Ignore malformed redirect URLs. */ }
  }
  if (value !== null) return value.trim();
  try {
    return sessionStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function captureSignupReferral(search = window.location.search, from?: string | null): string {
  const value = getSignupReferral(search, from);
  saveSignupReferral(value);
  return value;
}

// Replace the current URL too, so refresh and OAuth cannot revive the old ref.
export function updateSignupReferral(value: string): void {
  saveSignupReferral(value);
  const url = new URL(window.location.href);
  url.searchParams.set('ref', value.trim());
  window.history.replaceState(window.history.state, '', url);
}

export function clearSignupReferral(): void {
  try { sessionStorage.removeItem(STORAGE_KEY); } catch { /* Storage disabled. */ }
}

export function buildSocialLoginPath(provider: 'google' | 'naver' | 'kakao', redirect?: string | null): string {
  const params = new URLSearchParams(window.location.search);
  const target = redirect ?? params.get('redirect');
  const ref = captureSignupReferral(window.location.search, target);
  const query = new URLSearchParams({ platform: 'web', ref });
  if (target) query.set('redirect', target);
  return `/api/auth/social/${provider}?${query}`;
}
